module.exports = __webpack_public_path__ + "assets/img/llh_b1.97dee812.jpg";